import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onClose", "isOpen", "children", "variantProps", "dataTestId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Grid, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import { Dismiss } from '../../../../assets/icons';
import Icon from '../../../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function GalleryModal(_ref) {
  var _otherProps$portalPro;
  var onClose = _ref.onClose,
    isOpen = _ref.isOpen,
    children = _ref.children,
    variantProps = _ref.variantProps,
    dataTestId = _ref.dataTestId,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var prefix = dataTestId ? "".concat(dataTestId, "-") : '';
  var isInContainer = !!((_otherProps$portalPro = otherProps.portalProps) !== null && _otherProps$portalPro !== void 0 && _otherProps$portalPro.containerRef);
  return _jsxs(Modal, _objectSpread(_objectSpread({
    "data-testid": "".concat(prefix, "ChakraModal"),
    scrollBehavior: "inside",
    isCentered: true,
    isOpen: isOpen,
    onClose: onClose
  }, otherProps), {}, {
    children: [_jsx(ModalOverlay, _objectSpread({}, isInContainer && {
      width: '100%',
      height: '100%'
    })), _jsxs(ModalContent, _objectSpread(_objectSpread(_objectSpread({
      "data-testid": "".concat(prefix, "ModalContent")
    }, modalContentStyle(isInContainer)), {}, {
      width: isInContainer ? 'auto' : otherProps.size ? 'auto' : {
        mobile: 'full',
        lg: 'auto'
      },
      height: isInContainer ? 'fit-content' : {
        mobile: 'full',
        lg: 'fit-content'
      }
    }, isInContainer && {
      containerProps: {
        style: {
          width: '100%',
          height: '100%'
        }
      },
      mx: '1.5rem'
    }), {}, {
      children: [_jsx(ModalHeader, {
        p: "0",
        "data-testid": "".concat(prefix, "ModalHeader"),
        children: _jsxs(Flex, {
          flexDir: "column",
          children: [_jsxs(Grid, _objectSpread(_objectSpread({}, headerContentStyle), {}, {
            children: [variantProps && _jsx(Flex, _objectSpread(_objectSpread({}, headerTitleStyle), {}, {
              "data-testid": "".concat(prefix, "ModalTitle"),
              children: variantProps.title
            })), _jsx(ModalCloseButton, _objectSpread(_objectSpread({
              "data-testid": "".concat(prefix, "ModalCloseButton")
            }, modalCloseButtonStyle), {}, {
              children: _jsx(Icon, {
                svg: _jsx(Dismiss, {
                  transform: "scale(1.1)"
                })
              })
            }))]
          })), _jsx(Box, _objectSpread({}, delimiterModalStyle))]
        })
      }), _jsx(ModalBody, _objectSpread(_objectSpread({
        "data-testid": "".concat(prefix, "ModalBody")
      }, modalBodyStyle), {}, {
        children: _jsx(Box, {
          overflow: "auto",
          maxH: "calc(100vh - 4rem)",
          children: children
        })
      }))]
    }))]
  }));
}
var modalBodyStyle = {
  overflow: 'auto',
  p: 0
};
var modalContentStyle = isInContainer => ({
  maxW: 'auto',
  maxH: 'auto',
  overflow: 'auto',
  height: {
    mobile: 'full',
    lg: 'fit-content'
  },
  my: 0,
  borderRadius: {
    mobile: isInContainer ? '0.875rem' : '0',
    lg: '0.875rem'
  },
  boxShadow: '0 0.125rem 0.75rem var(--chakra-colors-darkGrey2)',
  px: '0'
});
var headerContentStyle = {
  m: 'md',
  gridTemplateColumns: '1fr auto',
  alignItems: 'center'
};
var delimiterModalStyle = {
  w: 'full',
  h: '0.063rem',
  bgColor: 'lightGrey4',
  display: {
    mobile: 'block',
    lg: 'none'
  }
};
var headerTitleStyle = {
  color: 'darkGrey1',
  justifyContent: 'center',
  fontSize: 'lg',
  lineHeight: '3',
  fontFamily: 'header',
  ml: 'xl',
  padding: 0
};
var modalCloseButtonStyle = {
  h: 'var(--chakra-space-xl)',
  w: 'var(--chakra-space-xl)',
  ml: 'auto',
  position: 'static',
  _focus: {
    boxShadow: 'none'
  },
  _hover: {
    bgColor: 'transparent'
  },
  _active: {
    bgColor: 'transparent'
  }
};